<template>
<header class="headPage">
	<el-row type="flex">
		<el-col :span="12" class="title">
			<img class="logo" src="../../assets/images/logo.png" alt="防雷减灾综合管理服务平台" title="防雷减灾综合管理服务平台">
			<router-link :to="'/'">防雷减灾综合管理服务平台</router-link>
		</el-col>
		<el-col :span="12" class="content">
			 欢迎!
			<span class="nickname">{{ userInfo }}</span>
			<div class="hanlde">
				<el-dropdown @command="handleCommand">
					<img src="../../assets/images/portrait.png" />
					<el-dropdown-menu slot="dropdown" class="userTab">
						<el-dropdown-item command="updatePassword">修改密码</el-dropdown-item>
						<el-dropdown-item  command="loginout">退出登录</el-dropdown-item>
					</el-dropdown-menu>
				</el-dropdown>
			</div>
		</el-col>
	</el-row>
	<update-password v-if="showUpdate" @close="showUpdate=false"></update-password>
</header>
</template>

<script>
import {mapMutations ,mapState} from 'vuex';
import updatePassword from './updatePassword'
export default {
  components:{
    'update-password':updatePassword
  },
	data() {
		return {
			userInfo:"",
			showUpdate:false
		}
	},
	props: [

	],
	computed: {

	},
	methods: {
		goIndex() {
			this.$router.push("/index");
		},
		getHelp(){
			this.$refs.helpBox.isVisible = true;
		},
		handleCommand(val){
			if(val == "updatePassword"){
				this.showUpdate = true;
			}else{
				localStorage.clear();
				this.$router.push("/login");
			}
		}
	},
	created(){
		setTimeout(() => {
			this.userInfo = localStorage.getItem("user");
		})
	}
}
</script>

<style lang="scss" scoped>
.headPage {
	position: fixed;
	top: 0;
	left: 0;
	width: 100%;
	height: 52px;
	z-index: 9;
	background: -webkit-linear-gradient(left, #28aaea, #38e7ea);
	background: -o-linear-gradient(right,#28aaea, #38e7ea);
	background: -moz-linear-gradient(right,#28aaea, #38e7ea);
	background: linear-gradient(to right,#28aaea, #38e7ea);
	.title {
		height: 52px;
		line-height: 52px;
		padding-left: 20px;
		color: #fff;
		font-size: 18px;
		text-align: left;
		background: none;
		.logo{
			display: block;
			float: left;
			margin-top:5px;
			width: 43px;
			height: 43px;
			margin-right:10px;
		}
		a {
			color: #fff;
			font-size: 18px;
			letter-spacing: 2px;
		}
	}
	.content {
		text-align: right;
		color: #fff;
		height: 52px;
		position: relative;
		line-height: 52px;
		font-size: 14px;
		.overview{
			margin-right:38px;
			color:#fff;
			font-size: 14px;
		}
		.helpBtn{
			cursor: pointer;
			margin-right: 38px;
			position: relative;
			font-size: 14px;
			top:2px;
		}
		.date {
			margin-right: 20px;
		}
		.nickname {
			margin-right: 90px;
			font-size: 14px;
		}
		.hanlde{
			position: absolute;
			right:24px;
			top:0;

			img {
				display: block;
				float: right;
				margin-top: 11px;
				width: 30px;
				height: 30px;
				border-radius: 15px;
				cursor: pointer;
			}
		}
	}
}
</style>




// WEBPACK FOOTER //
// src/components/basics/header.vue